import { type FC, type ReactNode } from "react";
import { Form, type FormInstance } from "antd";
import TrailInfoComponent from "../TrialInfoComponent/index";
import PlotDesignComponent from "../plotDesignComponent";
import RatesDosageComponent from "../ratesDosageComponent";
import SummaryComponent from "../SummaryComponent";
import FormNavigationButtons from "./FormNavigationButtons";

export interface TrialFormProps {
  form: FormInstance<any>;
  current: number;
  trialData: any;
  onFormFinish: (...args: any[]) => void;
  cancelLabel: string;
  nextLabel: string;
  isStepValid: boolean;
  isNextDisabled: boolean;
  onCancelClick: () => void;
  onNextClick: () => void;
}

const renderStepContent = (
  current: number,
  trialData: any,
  form: FormInstance<any>
): ReactNode => {
  switch (current) {
    case 0:
      return <TrailInfoComponent trialData={trialData} form={form} />;
    case 1:
      return <PlotDesignComponent trialData={trialData} />;
    case 2:
      return <RatesDosageComponent trialData={trialData} />;
    case 3:
      return <SummaryComponent />;
    default:
      return null;
  }
};

const TrialForm: FC<TrialFormProps> = ({
  form,
  current,
  trialData,
  onFormFinish,
  cancelLabel,
  nextLabel,
  isStepValid,
  isNextDisabled,
  onCancelClick,
  onNextClick,
}) => {
  return (
    <Form
      data-testid="form-basic"
      name="basic"
      onFinish={onFormFinish}
      form={form}
      onKeyDown={(e) => {
        if (e.key === "Enter") {
          e.preventDefault();
        }
      }}
      layout="vertical"
    >
      <div className={current === 3 ? "scroll-sec-3" : "scroll-sec"}>
        {renderStepContent(current, trialData, form)}
      </div>
      {current !== 3 && (
        <FormNavigationButtons
          cancelLabel={cancelLabel}
          nextLabel={nextLabel}
          isStepValid={isStepValid}
          isNextDisabled={isNextDisabled}
          onCancelClick={onCancelClick}
          onNextClick={onNextClick}
        />
      )}
    </Form>
  );
};

export default TrialForm;
